import styled from "styled-components";
import {darken, transitions} from "polished";

export const Menu = styled.ul`
    list-style-type: none;
    background: ${props => props.theme.colors.cardBg};
    color: ${props => props.theme.colors.cardFg};
    padding: 0;
    margin: 0;
    
    > li {
        box-sizing: border-box;
        
        &:not:has(>a, >button) {
            padding: .5rem;
            padding-right: 1.5rem;
            
            ${transitions(['color', 'background-color'], '.1s ease-in-out')}
            
            &:hover {
                background: ${props => props.theme.colors.primaryBg};
                color: ${props => props.theme.colors.primaryFg};
                font-weight: normal;
            }
        }
        
        >a, >button, >a.btn, >button.btn {
            box-sizing: border-box;
            display: flex !important;
            padding: .5rem;
            padding-right: 1.5rem;
            width: 100%;
            text-decoration: none;
            white-space: nowrap;
            
            ${transitions(['color', 'background-color'], '.1s ease-in-out')}
            
            &.btn {
                margin: 0;
            }
            
            &:hover, &.menu-selected {
                background: ${props => props.theme.colors.primaryBg};
                color: ${props => props.theme.colors.primaryFg};
                font-weight: normal;
            }
        }
    }
`;

export const PopupMenu = styled(Menu)`
    border: solid 1px ${props => darken(.1, props.theme.colors.cardBg)};
    box-shadow: 0.1rem 0.1rem 0.3rem rgba(0, 0, 0, 1);
`;
